const CURRENCY_BY_ISO = {
  USD: "$",
  EUR: "€",
  JPY: "¥",
  GBP: "£",
  AUD: "AU$",
  CAD: "CA$",
  CHF: "Fr",
  CNY: "¥",
  SEK: "kr",
  NZD: "$",
  MXN: "MX$",
  SGD: "SG$",
  HKD: "HK$",
  NOK: "kr",
  KRW: "₩",
  TRY: "₺",
  INR: "₹",
  RUB: "₽",
  BRL: "R$",
  ZAR: "R",
  DKK: "kr",
  PLN: "zł",
  THB: "฿",
  IDR: "Rp",
  HUF: "Ft",
  CZK: "Kč",
  ILS: "₪",
  CLP: "CL$",
  PHP: "₱",
  AED: "د.إ",
  COP: "CO$",
  DZD: "DZD"
};

export function currencyFromISO(iso: string): string {
  return CURRENCY_BY_ISO[iso as keyof typeof CURRENCY_BY_ISO];
}

export function getAllCurrency() {
  return CURRENCY_BY_ISO;
}
